export default [
    {
        "id": "user-page",
        "html": require('./user-page/html').default
    }
]